import React from 'react';
import { isChunkLoadError, reloadForStaleChunks } from '../utils/chunkReload';

type Props = {
  fallback?: React.ReactNode;
  children: React.ReactNode;
  onError?: (error: any, info: any) => void;
};

type State = { hasError: boolean; error?: any };

export default class ErrorBoundary extends React.Component<Props, State> {
  state: State = { hasError: false };

  static getDerivedStateFromError(error: any): State {
    return { hasError: true, error };
  }

  componentDidCatch(error: any, info: any) {
    if (isChunkLoadError(error) && reloadForStaleChunks('ErrorBoundary')) return;
    try { this.props.onError?.(error, info); } catch {}
    try { console.error('[ErrorBoundary]', error, info); } catch {}
  }

  render() {
    if (this.state.hasError) {
      const staleChunk = isChunkLoadError(this.state.error);
      return this.props.fallback ?? (
        <div className="p-4 rounded-lg border border-red-200 bg-red-50 text-red-800">
          <div className="font-semibold mb-1">
            {staleChunk ? 'Update available' : 'Something went wrong'}
          </div>
          <div className="text-sm">
            {staleChunk
              ? 'The app was updated. Please reload the page to continue.'
              : 'An unexpected error occurred while rendering this panel.'}
          </div>
          {staleChunk && (
            <button
              type="button"
              className="mt-3 px-3 py-1.5 rounded bg-red-600 text-white text-sm"
              onClick={() => window.location.reload()}
            >
              Reload page
            </button>
          )}
        </div>
      );
    }
    return this.props.children;
  }
}
 
